<template>
  <div id="territorio">
    <div class="row ">
    <div style="padding-left: 75px" class="col-12 directory">
      <router-link :to="{name: 'homepage'}">Home</router-link>
      / {{$t("scopri_territorio")}}
    </div>
    </div>
    <div class="row borghi">
      <div class="col-xl-6 col-12">
        <div class="title">{{$t("borghi")}}</div>
        <div class="testo" v-html="$t('desc_borghi')">

        </div>
      </div>
      <div class="col-xl-6 col-12">
        <img src="../../static/image/territorio/ponteDiavolo.jpg">
      </div>
    </div>
    <div class="row natura">
      <div class="col-xl-6 col-12 panorama">
        <img src="../../static/image/territorio/panoramaTerritorio.jpg">
      </div>
      <div class="col-xl-6 col-12">
        <div class="title">{{$t("natura")}}</div>
        <div class="testo" v-html="$t('desc_natura')">

        </div>
      </div>
    </div>
    <div class="row gastronomia">
      <div class="col-12">
        <div class="title">{{$t("cibo")}}</div>
        <br><br>
        <div class="testo" v-html="$t('desc_cibo')"></div>


          <div class="row">
            <div class="col-xl-4 col-12 testo" v-html="$t('elenco_vini')">

            </div>

            <div class="col-xl-4 col-12 testo" v-html="$t('elenco_salame')">

            </div>

            <div class="col-xl-4 col-12 testo" v-html="$t('elenco_piatti')">

            </div>
          </div>

      </div>
    </div>
    <div class="row arte">
      <div class="col-xl-6 col-12 container-testo">
        <div class="title">{{$t("citta")}}</div>
        <div class="testo" v-html="$t('desc_citta')">

        </div>
      </div>
      <div class="col-xl-6 col-12 certosa"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderPage from "./HeaderPage";
  import Footer from "./Footer";

  export default {
    name: "territorio",
    components: {Footer, HeaderPage},
    data() {
      return {}
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          scopri_territorio:'Scopri il territorio',
          borghi:'Borghi',
          desc_borghi:'Le splendide colline dell’Oltrepò sono costellate di piccoli borghi dal sapore antico come:<br><br>\n' +
            '          <b>Santa Maria della Versa</b>, uno dei paesi più famosi ed importanti per la vitivinicoltura\n' +
            '          dell’Oltrepò.<br><br>\n' +
            '          <b>Soriasco</b>, borgo medioevale che rappresenta l’antica Santa Maria della Versa.<br><br>\n' +
            '          <b>Golferenzo</b>, piccolo borgo panoramico in cui il tempo sembra essersi fermato.<br><br>\n' +
            '          <b>Varzi</b>, Borgo medioevale con il suo castello, famoso per l’omonimo Salame di Varzi<br><br>\n' +
            '          <b>Salice Terme</b>, Rivanazzano Terme, famosi centri termali per rilassarsi e prendersi cura di sé.<br><br>\n' +
            '          <b>Zavattarello</b>, luogo in cui potete visitare un bellissimo castello Medioevale che domina la\n' +
            '          valle.<br><br>\n' +
            '          <b>Fortunago</b>, uno dei borghi più belli d’Italia<br><br>\n' +
            '          <b>Sant’Alberto di Butrio</b> in Val di Nizza, Antico eremo isolato in una chiostra di monti, tra verdi\n' +
            '          pascoli, castagni, querce e abeti.<br><br>\n' +
            '          <b>Oramala e Montesegale</b> con i loro bellissimi castelli.<br><br>\n' +
            '          <b>Bobbio</b>, facente parte della provincia di Piacenza offre la possibilità di visitare un borgo antico sede\n' +
            '          del famoso “ponte del diavolo” o “ponte gobbo”<br><br>',
          natura:'Natura',
          desc_natura:'L’Oltrepò Pavese è una terra vocata alla produzione di vino, perfino la forma geografica del territorio\n' +
            '          ricorda\n' +
            '          un grappolo d’uva.<br>\n' +
            '          Alle porte di Milano, questo triangolo verde racchiude tesori culturali ed artistici come castelli e borghi\n' +
            '          medioevali, da scoprire e ammirare lungo percorsi a piedi, in bicicletta, in auto o motocicletta.<br><br>\n' +
            '\n' +
            '          Attraverso vigneti, colline, frutteti, boschi di querce e castagni fino ai paesaggi montani l’Oltrepò offre\n' +
            '          possibilità per tutti i gusti.<br><br>\n' +
            '\n' +
            '          In Val Tidone e Valle Staffora si trovano molte aree di interesse naturalistico come il Parco palustre di\n' +
            '          Lungavilla, la Riserva naturale Monte Alpe, il Giardino botanico alpino di Petra Corva e il Monte Penice.<br>\n' +
            '          Inoltre a Sant’Alessio con Vialone si trova l’Oasi di Sant’Alessio, area naturale protetta dove ammirare\n' +
            '          numerose specie di uccelli e farfalle.<br><br>\n',
          cibo:'Gastronomia',
          desc_cibo:'La gastronomia dell’Oltrepò esprime la tradizione e le tecniche antiche con la quale ancora oggi vengono\n' +
            '          prodotti gustosi piatti, salumi, formaggi e dolci, ovviamente gustando il tutto con gli ottimi vini di questa\n' +
            '          terra.<br><br>',
          elenco_vini:' Alcuni vini del territorio:<br><br>\n' +
            '              <b>Bonarda</b><br>\n' +
            '              <b>Pinot Nero rosso</b><br>\n' +
            '              <b>Pinot Nero spumante Metodo Classico</b><br>\n' +
            '              <b>Riesling</b><br>\n' +
            '              <b>Buttafuoco</b><br>\n' +
            '              <b>Sangue di Giuda</b><br>\n' +
            '              <b>Moscato di Volpara</b><br><br>',
          elenco_salame:'Prodotti tipici:<br><br>\n' +
            '              <b>Salame di Varzi</b><br>\n' +
            '              <b>Pancetta con cotenna</b><br>\n' +
            '              <b>Miccone di Stradella ( pane)</b><br>\n' +
            '              <b>Biscotti Brasadè</b><br>\n' +
            '              <b>Formaggi di vacca e capra quali Molana, Stafforella, etc...</b><br>\n' +
            '              <b>Zucca berrettina</b><br>\n' +
            '              <b>Mela Pomella Genovese ( o mela di Varzi)</b><br>\n' +
            '              <b>Peperone di Voghera</b><br>\n' +
            '              <b>Vacca Varzese</b><br>\n' +
            '              <b>Cipolla di Breme</b><br>\n' +
            '              <b>Riso</b><br><br>',
          elenco_piatti:'Piatti Tipici:<br><br>\n' +
            '              <b>Ravioli di brasato</b><br>\n' +
            '              <b>Tortelli di magro</b><br>\n' +
            '              <b>Zuppa Pavese</b><br>\n' +
            '              <b>Risotto ai peperoni</b><br>\n' +
            '              <b>Stoccafisso alla Varzese</b><br>\n' +
            '              <b>Salame cotto</b><br>\n' +
            '              <b>Risotto al Bonarda e salsiccia</b><br>\n' +
            '              <b>Risotto allo spumante</b><br>\n' +
            '              <b>Bollito misto</b><br>\n' +
            '              <b>Salsa Peverada</b><br>\n' +
            '              <b>Risotto alla zucca</b><br>\n' +
            '              <b>Malfatti</b><br>\n' +
            '              <b>Ragò</b><br>\n' +
            '              <b>Torta Paradiso</b><br>',
          citta:'Città, Arte, Cultura e Shopping',
          desc_citta:'<b>Pavia</b> e il suo centro storico ricco di monumenti, arte, cultura e negozi per poter fare acquisti<br>\n' +
            '          <b>La Certosa di Pavia</b> ( monastero e santuario)<br>\n' +
            '          <b>Stradella, Broni, Casteggio, Voghera</b>: piccoli centri per fare una passeggiata, acquisti o partecipare\n' +
            '          ai numerosi eventi estivi<br><br>\n' +
            '\n' +
            '\n' +
            '          A una distanza di circa 50-100 km avete la possibilità di visitare anche:<br>\n' +
            '          <b>Milano</b>,<br>\n' +
            '          <b>Piacenza</b>,<br>\n' +
            '          <b>Vigevano</b>,<br>\n' +
            '          <b>Castell’Arquato</b>,<br>\n' +
            '          <b>Vigoleno</b>,<br>\n' +
            '          <b>Cremona</b>,<br>\n' +
            '          <b>Parma</b>,<br>\n' +
            '          <b>Asti</b>,<br>\n' +
            '          <b>Acqui Terme</b>,<br>\n' +
            '          <b>Serravalle Designer Outlet</b>.<br>',
        },
        en: {
          scopri_territorio:' Discover the Area',
          borghi:'Villages',
          desc_borghi:'The beautiful hills of Oltrepò are dotted with small villages with an ancient flavor such as:<br><br>\n' +
            '          <b>Santa Maria della Versa</b>, one of the most famous and important wine-growing villages in the\n' +
            'Oltrepò.<br><br>\n' +
            '          <b>Soriasco</b>, a medieval village that represents the ancient Santa Maria della Versa<br><br>\n' +
            '          <b>Golferenzo</b>, small scenic village where time seems to stand still.<br><br>\n' +
            '          <b>Varzi</b>, medieval village with its castle, famous for its namesake Salame di Varzi.<br><br>\n' +
            '          <b>Salice Terme</b>, Rivanazzano Terme,  famous spas to relax and take care of yourself.<br><br>\n' +
            '          <b>Zavattarello</b>, a place where you can visit a beautiful medieval castle overlooking the valley.<br><br>\n' +
            '          <b>Fortunago</b>, one of the most beautiful villages in Italy<br><br>\n' +
            '          <b>Sant’Alberto di Butrio</b> in Val di Nizza, Ancient hermitage isolated in a cloister of mountains,\n' +
            'among green pastures\n' +
            '          chestnut, oak and fir trees.<br><br>\n' +
            '          <b>Oramala e Montesegale</b> with their beautiful castles.<br><br>\n' +
            '          <b>Bobbio</b>, part of the province of Piacenza offers the opportunity to visit an ancient village home\n' +
            '          to the famous “devil\'s bridge” or “hunchback bridge”<br><br>',
          natura:'Nature',
          desc_natura:'L’Oltrepò Pavese  is a land devoted to wine production, even the geographical shape of the area\n' +
            '         resembles a bunch of grapes.<br>\n' +
            '          At the gates of Milan, this green triangle holds cultural and artistic treasures such as castles\n' +
            'and medieval villages\n' +
            '          to be discovered and admired along routes on foot, by bicycle, car or\n' +
            'motorcycle.<br><br>\n' +
            '\n' +
            '          Through vineyards, hills, orchards, oak and chestnut forests to mountain landscapes, Oltrepò\n' +
            'offers\n' +
            '          possibilities for all tastes.<br><br>\n' +
            '\n' +
            '          In the Tidone Valley and Staffora Valley there are many areas of natural interest such as the\n' +
            'Lungavilla Marsh Park\n' +
            '          Monte Alpe Nature Reserve, Petra Corva Alpine Botanical Garden, and\n' +
            'Monte Penice.<br>\n' +
            '          Also in Sant\'Alessio con Vialone is the Sant\'Alessio Oasis, a protected natural area where you\n' +
            '          can admire many species of birds and butterflies.<br><br>\n',
          cibo:'Gastronomy',
          desc_cibo:'The gastronomy of the Oltrepò expresses the tradition and ancient techniques with which\n' +
            '          tasty dishes, cold cuts, cheeses and desserts are still produced today, of course enjoying\n' +
            '          everything with the excellent wines of this land.<br><br>',
          elenco_vini:' Some local wines:<br><br>\n' +
            '              <b>Bonarda</b><br>\n' +
            '              <b>Pinot Nero rosso</b><br>\n' +
            '              <b>Pinot Nero spumante Metodo Classico</b><br>\n' +
            '              <b>Riesling</b><br>\n' +
            '              <b>Buttafuoco</b><br>\n' +
            '              <b>Sangue di Giuda</b><br>\n' +
            '              <b>Moscato di Volpara</b><br><br>',
          elenco_salame:'Typical products:<br><br>\n' +
            '              <b>Salame di Varzi</b><br>\n' +
            '              <b>Pancetta con cotenna</b><br>\n' +
            '              <b>Miccone di Stradella ( pane)</b><br>\n' +
            '              <b>Biscotti Brasadè</b><br>\n' +
            '              <b>Formaggi di vacca e capra quali Molana, Stafforella, etc...</b><br>\n' +
            '              <b>Zucca berrettina</b><br>\n' +
            '              <b>Mela Pomella Genovese ( o mela di Varzi)</b><br>\n' +
            '              <b>Peperone di Voghera</b><br>\n' +
            '              <b>Vacca Varzese</b><br>\n' +
            '              <b>Cipolla di Breme</b><br>\n' +
            '              <b>Riso</b><br><br>',
          elenco_piatti:'Typical Dishes:<br><br>\n' +
            '              <b>Ravioli di brasato</b><br>\n' +
            '              <b>Tortelli di magro</b><br>\n' +
            '              <b>Zuppa Pavese</b><br>\n' +
            '              <b>Risotto ai peperoni</b><br>\n' +
            '              <b>Stoccafisso alla Varzese</b><br>\n' +
            '              <b>Salame cotto</b><br>\n' +
            '              <b>Risotto al Bonarda e salsiccia</b><br>\n' +
            '              <b>Risotto allo spumante</b><br>\n' +
            '              <b>Bollito misto</b><br>\n' +
            '              <b>Salsa Peverada</b><br>\n' +
            '              <b>Risotto alla zucca</b><br>\n' +
            '              <b>Malfatti</b><br>\n' +
            '              <b>Ragò</b><br>\n' +
            '              <b>Torta Paradiso</b><br>',
          citta:'City, Art, Culture and Shopping',
          desc_citta:'<b>Pavia</b>  and its historic center full of monuments, art, culture and stores to be able to store<br>\n' +
            '          <b>La Certosa di Pavia</b> (monastery and sanctuary)<br>\n' +
            '          <b>Stradella, Broni, Casteggio, Voghera: small towns to take a walk, shop or participate in the\n' +
            '          many summer events<br><br>\n' +
            '\n' +
            '\n' +
            '          At a distance of about 50-100 km you also have the opportunity to visit:<br>\n' +
            '          <b>Milano</b>,<br>\n' +
            '          <b>Piacenza</b>,<br>\n' +
            '          <b>Vigevano</b>,<br>\n' +
            '          <b>Castell’Arquato</b>,<br>\n' +
            '          <b>Vigoleno</b>,<br>\n' +
            '          <b>Cremona</b>,<br>\n' +
            '          <b>Parma</b>,<br>\n' +
            '          <b>Asti</b>,<br>\n' +
            '          <b>Acqui Terme</b>,<br>\n' +
            '          <b>Serravalle Designer Outlet</b>.<br>',
        },
      }
    },
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #territorio {
    letter-spacing: 1px;
    .row {
      margin-right: 0px !important;
      margin-left: 0px !important;
    }
    .directory {
      background-color: @lightBlack;
      padding: 20px;
      padding-top: 100px;
      padding-left: 40px;
      .set-font-latoLight(@size: 16px);
    }
    .borghi {
      background-color: @lightBlack;
      text-align: center;
      padding: 20px;
      padding-top: 50px;
      padding-left: 60px;
      .title {
        .set-font-title(@size: 35px)
      }
      .testo {
        text-align: left;
        line-height: initial;
        .set-font()
      }
    }
    .natura {
      text-align: center;
      padding: 20px;
      background-color: white;
      .panorama{
        padding-top: 52px;
      }
      .title {
        .set-font-title(@size: 35px, @color: @lightBlack)
      }
      .testo {
        text-align: left;
        .set-font(@color: @lightBlack);
        .valleversa{
          .set-font-latoBold(@color: @lightBlack, @size: 16px)
        }
      }
    }
    .gastronomia {
      background-image: url("../../static/image/territorio/gastronomia.jpg");
      text-align: center;
      padding: 20px;
      padding-left: 60px;
      padding-right: 45px;
      min-height: 1000px;
      background-size: cover;
      .title {
        .set-font-title(@size: 35px)
      }
      .testo {
        text-align: left;
        .set-font()
      }
    }
    .arte {
      text-align: center;
      background-color: white;
      .container-testo{
        padding: 30px;
        padding-left: 60px;
        .title {
          .set-font-title(@size: 35px, @color: @lightBlack)
        }
        .testo {
          text-align: left;
          .set-font(@color: @lightBlack)
        }
      }
      .certosa{
        background-image: url("../../static/image/territorio/certosa.jpg");
        background-size: cover;
      }
    }
  }
  @media (max-width: 767px) {

    img{
      width: 100%;
    }
    #territorio {
      letter-spacing: 1px;
      .directory {
        padding: 20px;
        padding-top: 80px;
        .set-font-latoLight(@size: 13px);
      }
      .borghi {
        padding: 20px;
        .title {
          .set-font-title(@size: 28px)
        }
        .testo {
          .set-font()
        }
      }
      .natura {
        padding: 20px;
        .panorama {
          padding-top: 10px;
        }
        .title {
          .set-font-title(@size: 28px, @color: @lightBlack)
        }
        .testo {
          .set-font(@color: @lightBlack);
          .valleversa {
          }
        }
      }
      .gastronomia {
        padding: 20px;
        min-height: 1000px;
        line-height: initial;
        .title {
          .set-font-title(@size: 28px)
        }
        .testo {
          .set-font()
        }
      }
      .arte {
        .container-testo {
          padding: 20px;
          .title {
            .set-font-title(@size: 28px, @color: @lightBlack)
          }
          .testo {
            .set-font(@color: @lightBlack)
          }
        }
        .certosa {
          min-height: 300px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Territorio.vue